import { PoiContainer } from './LocationSearchList';
import PoiCardShimmer from '../../../shop-dine-relax/ui/PoiCardShimmer';

export default function LocationSearchShimmer() {
	return (
		<PoiContainer>
			<PoiCardShimmer />
			<PoiCardShimmer />
			<PoiCardShimmer />
			<PoiCardShimmer />
		</PoiContainer>
	);
}
